export default __webpack_public_path__ + "static/media/2041.0528280b.png";